module.exports = __webpack_public_path__ + "img/flow_1.bcd62c9c.png";